export default __webpack_public_path__ + "static/assets/cf26d6037a9b4fbba6e980fbc0a4693c.png";